<template>
    <div class="home-section-box" v-if="item" :key="item.id">
        <div v-if="item.origin_type === 2" class="article-list-section">
            <van-row class="article-list-section-box" @click="go_article_detail(item)">
                <van-col span="9">
                    <van-image
                        fit="cover"
                        class="article-list-content-img"
                        :src="item.cover_img"
                        width="100%"
                        height="74"
                    />
                    <div class="article-list-section-left-zl" v-if="item.type == 2">
                        图文专题
                    </div>
                    <div v-else :class="[item.origin_type === 3 ? 'article-list-section-left-zl' : '']">
                        {{ item.origin_type === 3 ? item.type_text : '' }}
                    </div>
                </van-col>
                <van-col span="15" class="article-list-content">
                    <div class="article-list-title">{{ item.title }}</div>
                    <div class="article-list-content-detail">
                        <div v-if="!item.current_count && !item.total_count && item.created_at">
                            {{ item.created_at | formatTime }}
                            <span style="margin-left: 8px">{{ item.view_count }}人阅读</span>
                        </div>
                        <div v-else>已更新{{ item.current_count }}节 | 共{{ item.total_count }}节</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div v-if="item.origin_type === 4" class="live-list-section" style="padding-bottom: 0">
            <van-row @click="go_live_detail(item)">
                <div class="live-list-section-box" style="padding-bottom: 0">
                    <div class="live-list-section-left">
                        <img class="live-list-section-left-img" :src="item.cover_img" />
                        <div v-if="item.type == 2" class="live-list-section-left-zl">
                            直播专题
                        </div>
                        <div v-else-if="item.live_status == 0" class="live-list-section-left-zl">
                            直播预告
                        </div>
                        <div v-else-if="item.live_status == 1" class="live-list-section-left-zl">
                            <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> 直播中
                        </div>
                        <div v-else class="live-list-section-left-zl">
                            <!-- 直播回放 -->
                            直播回放
                        </div>
                        <div class="live-list-section-left-time" v-if="item.live_status > 1">
                            <span>{{ item.duration_format }}</span>
                        </div>
                    </div>
                    <div class="live-list-section-right">
                        <div class="live-list-section-right-title" v-html="item.title"></div>
                        <div class="live-list-section-right-detail" style="bottom: 0">
                            <span v-if="item.type === 2">共{{ item.total_count }}期</span>
                            <span v-else-if="item.live_status < 2">{{ item.start_at }}</span>
                            <span v-else>{{ item.view_count }}人观看</span>
                            <span
                                class="live-list-section-right-detail-join"
                                v-if="item.type === 1 && item.live_status < 2"
                            >
                                <span>{{
                                    item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入'
                                }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </van-row>
        </div>
        <div v-if="item.origin_type == 3" class="course-list-section" style="padding-bottom: 0">
            <van-row @click="go_video_detail(item)">
                <div class="course-list-section-box">
                    <div class="course-list-section-left">
                        <van-image
                            fit="cover"
                            class="course-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="72"
                        />
                        <div class="play-button">
                            <van-icon name="play" />
                        </div>
                        <div v-if="item.origin_type == 2" class="course-list-section-left-zl">
                            视频专栏
                        </div>
                        <div class="course-list-section-left-zl" v-else>
                            精彩视频
                        </div>
                    </div>
                    <div class="course-list-section-right">
                        <div class="course-list-section-right-title">
                            {{ item.title }}
                        </div>
                        <div class="course-list-section-right-detail" v-if="item.origin_type == 2">
                            已更新{{ item.current_count }}节 | 共{{ item.total_count }}节
                        </div>
                        <div class="course-list-section-right-detail" v-else>{{ item.view_count }}人学习</div>
                    </div>
                </div>
            </van-row>
        </div>
    </div>
</template>

<script>
import Interface from '../../util/interface'

export default {
    props: {
        item: {
            type: Object
        }
    },
    filters: {
        formatTime(value) {
            if (value) {
                return value.split(' ')[0] + '日'
            }
            // return +1
        }
    },
    methods: {
        // 获得详情
        goDetails(row) {
            this.$router.push({ name: 'manual-details', params: { id: row } })
        },
        onClick() {
            this.fetch('channelContent')
        },
        go_detail(item) {
            if (item.origin_type != 2) {
                this.$router.push({ name: 'course-detail', params: { id: item.id } })
            } else {
                this.$router.push({ name: 'course-column', params: { id: item.id } })
            }
        },
        go_live_detail(item) {
            Interface.goLive(this, item.origin_id, item.type, item.live_status)
        },
        go_video_detail(item) {
            Interface.goVideo(this, item.origin_id, item.type)
        },
        go_article_detail(item) {
            Interface.goArticle(this, item.origin_id, item.type)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/course-list.scss';
@import '@/components/live-list.scss';
@import '@/components/live-column.scss';
@import '@/components/article-list.scss';
@import '@/components/short-video-list.scss';

@import '@/styles/activity-list.scss';
@import '@/styles/clinic-list.scss';
@import '@/styles/community-list.scss';
@import '@/styles/comrade-list.scss';
@import '@/styles/diagnose-list.scss';
@import '@/styles/guide-list.scss';
@import '@/styles/knowledge-list.scss';

.anticancer-container-list-main {
    background: #f5f5f6;
    display: flex;
    justify-content: center;

    &-item {
        flex-direction: column;
        background-color: #fff;
        margin: 0px 10px;
        border-radius: 10px;

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            padding: 4px 12px;
        }

        &-content-tips {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #777777;
            letter-spacing: 0;
            padding: 0px 12px;
        }

        &-tags-list {
            margin: 12px 0px;
            padding: 0px 12px;
            span {
                display: inline-block;
                background-color: #fff9f1;
                padding: 3px 5px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #fea253;
                letter-spacing: 0;
            }
        }

        .van-image__img {
            width: 355px;
            height: 200px;
        }
    }
}

.list-item {
    background-color: #fff;
    margin: 10px 8px;
    border-radius: 10px;
    display: flex;

    &-left {
        position: relative;
        width: 130px;
        height: 73px;
        padding: 10px;

        img {
            border-radius: 5px;
        }

        .van-image {
            width: 120px;
            height: 73px;
        }

        .special {
            position: absolute;
            top: 14px;
            left: 14px;
            color: #fff;
            background-color: #fda44a;
            font-size: 10px;
            padding: 2px 5px;
            border-radius: 3px;
            border-radius: 3px;
        }
    }

    &-right {
        color: #333;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        box-sizing: border-box;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 13px;
            color: #222222;
            letter-spacing: 0;
            padding-right: 20px;
        }

        .list-item-tips {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;

            .date {
                margin-right: 10px;
            }
        }
    }
}

.live-list-section,
.course-list-section,
.article-list-section {
    background-color: #ffffff;
    padding-top: 14px;
    margin: 10px 8px;
    border-radius: 10px;
    padding-bottom: 8px !important;

    .article-list-section-box:after {
        padding-top: 0 !important;
        margin-bottom: 0px;
    }
    .article-list-content {
        height: 0px;
    }

    .article-list-content-detail {
        white-space: nowrap;
    }

    .course-list-section-box {
        margin: 0px;
    }

    .live-list-section-right-title,
    .course-list-section-right-title {
        padding-right: 30px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
    }
    .course-list-section-right .course-list-section-right-detail {
        font-size: 12px;
    }

    .course-list-section-left {
        position: relative;
        .play-button {
            width: 22px;
            height: 14px;
            background: rgba(255, 255, 255, 0.7);
            border-radius: 9px;
            position: absolute;
            right: 3px;
            bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
        }
    }
}
.knowledge-list-sidebar-section {
    height: inherit;
    margin: 10px 8px;
}

.manual-item {
    background-color: #fff;
    color: #333;
    margin: 10px 8px auto;
    padding: 10px;
    border-radius: 2px;
    display: flex;

    &-left {
        position: relative;
        .van-image {
            height: 120px;
            width: 90px;
        }

        .describe {
            position: absolute;
            top: 42px;
            left: 26px;
            color: #fff;
            font-size: 12px;
            width: 40px;
            text-align: center;
        }
    }

    &-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;
        flex: 1;
        .title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            line-height: 24px;
        }

        -text {
            flex: 1;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #777777;
            letter-spacing: 0;
            line-height: 20px;
        }
        &-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .apply {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #0cc4b9;
                text-align: center;

                .van-icon {
                    font-size: 15px;

                    margin-right: 3px;
                }
            }

            .read-btn {
                .van-button__text {
                    font-size: 10px;
                    height: 26px;
                    line-height: 26px;
                    padding: 5px 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/doctor-details/item.vue